export default __webpack_public_path__ + "static/media/cpv_51_installation.cfb56c25.svg";